import { PerlRestApiResult } from '../../api/RestApiManager';
import { ActionResult, NoticeType } from '../../typings/grid';

export const ERROR_PROPORTION_CHECKPOINT = 0.2;
export const SUCCESS_PROPORTION_CHECKPOINT = 0.8;

export function getRequestResultNoticeParams(
    allRequestItems: number,
    successItems: number
): {
    noticeType: NoticeType;
    noticeMessageType: NoticeType;
} {
    const successProportion = successItems / allRequestItems;

    let noticeType: NoticeType;
    let noticeMessageType: NoticeType;

    if (successProportion === 1) {
        noticeType = NoticeType.success;
        noticeMessageType = NoticeType.success;
    } else if (successProportion === 0) {
        noticeType = NoticeType.error;
        noticeMessageType = NoticeType.error;
    } else if (successProportion <= ERROR_PROPORTION_CHECKPOINT) {
        noticeType = NoticeType.error;
        noticeMessageType = NoticeType.warning;
    } else if (successProportion >= SUCCESS_PROPORTION_CHECKPOINT) {
        noticeType = NoticeType.success;
        noticeMessageType = NoticeType.warning;
    } else {
        noticeType = NoticeType.warning;
        noticeMessageType = NoticeType.warning;
    }

    return {
        noticeType,
        noticeMessageType
    };
}

export function getNoticeTypeFromSuccessfulItemsRatioStrict(successCount: number, skippedCount: number): NoticeType {
    switch (true) {
        case successCount > 0 && skippedCount === 0:
            return NoticeType.success;

        case successCount === 0 && skippedCount > 0:
            return NoticeType.error;

        default:
            return NoticeType.warning;
    }
}

export function getNoticeParamsForMassAction(response: PerlRestApiResult, selectionCount?: number): ActionResult {
    let noticeType: NoticeType;
    const { updated_objects = [], skipped_objects = [], status, array_errors } = response;

    const successCount = updated_objects.length;
    const skippedCount = skipped_objects.length;
    const isObjectsEmpty = !response.updated_objects && !response.skipped_objects;

    if ((status && status === 'error') || (array_errors && array_errors.length)) {
        noticeType = NoticeType.error;
    } else if (isObjectsEmpty) {
        noticeType = NoticeType.success;
    } else {
        noticeType =
            selectionCount === undefined
                ? getNoticeTypeFromSuccessfulItemsRatioStrict(successCount, skippedCount)
                : getRequestResultNoticeParams(selectionCount, successCount).noticeType;
    }

    return {
        successCount,
        skippedCount,
        noticeType
    };
}
